import React from 'react';
import { filter } from 'lodash';

import { DualMatchCard, DualMatchCardEdit } from '../../cards';
import PopOverMenu from '../../PopOverMenu';

import styles from '../dualMatch.scss';
import { ratingTypes } from '../../../utils/constants';

const _ = { filter };

const ResultsTabTmsDualMatch = (props) => {
    const {
        event,
        auth,
        isAdmin,
        playersDict,
        teamsDict,
        team1Players,
        team2Players,
        handlePostScore,
        teams,
        handlePlayerSelect,
        handleTeamSelect,
        handleAddMatch,
        handleDeleteMatch,
        eventTeams,
        showAddDrawPopup,
        adminDrawOptions,
        handleAdminDrawOptionSelect,
        isSaving,
        isCollegeDualMatch,
    } = props;

    const isUserPowered = auth && auth.user && auth.user.isPowered;
    const isUserLoggedIn = auth && auth.user;

    const singlesDraws = _.filter(event.draws, { drawFormatType: { value: 'singles' } });
    const doublesDraws = _.filter(event.draws, { drawFormatType: { value: 'doubles' } });

    const utrType = event.utrType.value;
    const eventDate = event.eventSchedule.eventStartShort;
    const { published, sportTypeId } = event;

    const ResultListHeader = (resultHeaderProps) => {
        return (
            <div className="col">
                <div className={`result-header-title-wrapper ${isCollegeDualMatch ? styles.themeV3 : ''}`}>
                    <div className={`d-flex aic`}>
                        <h6>
                            {resultHeaderProps.drawName}
                        </h6>
                        {!published && !isCollegeDualMatch && (
                            <PopOverMenu
                                horizontalEllipsis={false}
                                menuItems={adminDrawOptions}
                                onSelected={(option) => handleAdminDrawOptionSelect(option, resultHeaderProps.drawId, resultHeaderProps.drawName)}
                                anchorClass="pop-over-menu-nchor"
                            />
                        )}

                        {!published && isCollegeDualMatch && (
                            <div className={`d-flex ${styles.actionLinks}`}>
                                {adminDrawOptions.map(v => (
                                    <div className={`${styles.link}`} onClick={() => handleAdminDrawOptionSelect(v, resultHeaderProps.drawId, resultHeaderProps.drawName)} key={v.value} data-testid={`dual-match.results.admin-option-${v.value}`}>{v.label}</div>
                                ))}
                                <div className={`link clickable d-md-block ${isCollegeDualMatch ? styles.link : ''}`} onClick={() => showAddDrawPopup()} data-testid="dual-match.results.add-lineup-btn">Add Lineup</div>
                            </div>
                        )}
                        {isAdmin && !isCollegeDualMatch && resultHeaderProps.showAddDrawLink && (
                            <div className={`link clickable ml-auto d-none d-md-block ${isCollegeDualMatch ? styles.link : ''}`} onClick={() => showAddDrawPopup()} data-testid="dual-match.results.add-lineup-desktop-btn">Add Lineup</div>
                        )}
                    </div>
                    <div className="d-block">
                        <span className="subtitle">{resultHeaderProps.matchCount} {resultHeaderProps.matchCount === 1 ? 'match' : 'matches'}</span>
                    </div>
                </div>
                <hr className="mt0 mb4" />
                <div className={`d-block d-md-none text-small text-medium result-header`}>
                    <div className="row pr0">
                        <div className="col pl0 pr0">
                            <div className="d-flex">
                                <div className="rank" />
                                <div className="flex-2">
                                    Players
                                </div>
                                <div className="flex-1">
                                    {isUserLoggedIn && !isAdmin && ratingTypes.tennis}
                                </div>
                                <div className="flex-1 tms-score">
                                    Score
                                </div>
                                <div className="winner-display" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`d-none d-md-block text-small text-medium result-header`}>
                    <div className="row pr0">
                        <div className="col-9">
                            <div className="d-flex">
                                <div className="rank" />
                                <div className="flex-3">
                                    Players
                                </div>
                                <div className="flex-1">
                                    {isUserLoggedIn && !isAdmin && ratingTypes.tennis}
                                </div>
                                <div className="flex-1 tms-score">
                                    Score
                                </div>
                                <div className="winner-display" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const renderDoublesDraw = () => {
        return (doublesDraws.length > 0 || isAdmin) && (
            (doublesDraws.map((doublesDraw, index) => {
                const doublesMatches = doublesDraw && doublesDraw.rounds[0] ? doublesDraw.rounds[0].matches : [];
                const doublesRoundId = doublesDraw && doublesDraw.rounds[0] ? doublesDraw.rounds[0].id : null;
                const isPlayerExists = isCollegeDualMatch ? doublesMatches.filter(match => match.position1 != null || match.position2 != null).length : doublesMatches.filter(match => match.result).length;
                return (
                    <React.Fragment key={`doubles-result-fragment-${index}`}>
                        <ResultListHeader
                            drawId={doublesDraw.id}
                            drawName={doublesDraw.name}
                            isUserPowered={isUserPowered}
                            matchCount={published ? isPlayerExists : doublesMatches.length}
                            showAddDrawLink={!singlesDraws.length && index === 0}
                        />
                        {doublesMatches.map((match, i) => {
                            return (
                                <div
                                    key={`doubles-result-${i}`}
                                    className="col-12"
                                >
                                    {isAdmin ? (
                                        <DualMatchCardEdit
                                            index={i + 1}
                                            matchObj={match}
                                            playersDict={playersDict}
                                            teamsDict={teamsDict}
                                            teams={teams}
                                            eventTeams={eventTeams}
                                            team1Players={team1Players}
                                            team2Players={team2Players}
                                            // singlesDraw={singlesDraw}
                                            doublesDraw={doublesDraw}
                                            eligibleResults={doublesMatches}
                                            gameType={'doubles'}
                                            utrType={utrType}
                                            round={null}
                                            showVerified={true}
                                            handlePostScore={handlePostScore}
                                            handlePlayerSelect={handlePlayerSelect}
                                            handleTeamSelect={handleTeamSelect}
                                            handleDeleteMatch={handleDeleteMatch}
                                            eventDate={eventDate}
                                            disablePostScoreButton={isSaving}
                                            sportTypeId={sportTypeId}
                                        />
                                    )
                                        : (
                                            <DualMatchCard
                                                {...match.result}
                                                matchObj={match}
                                                teamsDict={teamsDict}
                                                isCollegeDualMatch={isCollegeDualMatch}
                                                index={i + 1}
                                                eventTeams={eventTeams}
                                                team1Players={team1Players}
                                                team2Players={team2Players}
                                                eligibleResults={doublesMatches}
                                                gameType={'doubles'}
                                                round={null}
                                                showVerified={true}
                                                eventDate={eventDate}
                                                sportTypeId={sportTypeId}
                                            />
                                        )}
                                </div>
                            );
                        })}
                        {isAdmin && (
                            <div className={`col-12 mt8 mb16 ${!doublesMatches.length ? 'text-center' : ''}`}>
                                <div className={`link clickable`} onClick={() => handleAddMatch(doublesDraw.id, doublesRoundId)} data-testid="dual-match.results.add-doubles-match-btn">Add doubles match</div>
                            </div>
                        )}
                        {published && !doublesMatches.filter(match => match.position1 != null || match.position2 != null).length && (
                            <div className={`col-12 mb24 text-center fs14`}>No matches have been posted yet.</div>
                        )}
                    </React.Fragment>
                );
            }))
        );
    };

    const renderSinglesDraw = () => {
        return (singlesDraws.length > 0 || isAdmin) && (
            (singlesDraws.map((singlesDraw, index) => {
                const singlesMatches = singlesDraw && singlesDraw.rounds[0] ? singlesDraw.rounds[0].matches : [];
                const singlesRoundId = singlesDraw && singlesDraw.rounds[0] ? singlesDraw.rounds[0].id : null;
                const isPlayerExists = isCollegeDualMatch ? singlesMatches.filter(match => match.position1 != null || match.position2 != null).length : singlesMatches.filter(match => match.result).length;
                return (
                    <React.Fragment key={`singles-result-fragment-${index}`}>
                        <ResultListHeader
                            drawId={singlesDraw.id}
                            drawName={singlesDraw.name}
                            matchCount={published ? isPlayerExists : singlesMatches.length}
                            showAddDrawLink={singlesDraws.length > 0 && index === 0}
                        />
                        {singlesMatches.map((match, i) => {
                            return (
                                <div
                                    key={`singles-result-${i}`}
                                    className="col-12"
                                >
                                    {isAdmin ? (
                                        <DualMatchCardEdit
                                            index={i + 1}
                                            matchObj={match}
                                            playersDict={playersDict}
                                            teamsDict={teamsDict}
                                            eventTeams={eventTeams}
                                            team1Players={team1Players}
                                            team2Players={team2Players}
                                            singlesDraw={singlesDraw}
                                            // doublesDraw={doublesDraw}
                                            eligibleResults={singlesMatches}
                                            gameType={'singles'}
                                            utrType={utrType}
                                            round={null}
                                            showVerified={true}
                                            handlePostScore={handlePostScore}
                                            handlePlayerSelect={handlePlayerSelect}
                                            handleTeamSelect={handleTeamSelect}
                                            handleDeleteMatch={handleDeleteMatch}
                                            eventDate={eventDate}
                                            disablePostScoreButton={isSaving}
                                            sportTypeId={sportTypeId}
                                        />
                                    )
                                        : (
                                            <DualMatchCard
                                                {...match.result}
                                                matchObj={match}
                                                isCollegeDualMatch={isCollegeDualMatch}
                                                teamsDict={teamsDict}
                                                index={i + 1}
                                                eventTeams={eventTeams}
                                                team1Players={team1Players}
                                                team2Players={team2Players}
                                                eligibleResults={singlesMatches}
                                                gameType={'singles'}
                                                round={null}
                                                showVerified={true}
                                                eventDate={eventDate}
                                                sportTypeId={sportTypeId}
                                            />
                                        )}
                                </div>
                            );
                        })}
                        {isAdmin && (
                            <div className={`col-12 mt8 mb16 ${!singlesMatches.length ? 'text-center' : ''}`}>
                                <div className={`link clickable`} onClick={() => handleAddMatch(singlesDraw.id, singlesRoundId)} data-testid="dual-match.results.add-singles-match-btn">Add singles match</div>
                            </div>
                        )}
                        {published && !singlesMatches.filter(match => match.position1 != null || match.position2 != null).length && (
                            <div className={`col-12 mb24 text-center fs14`}>No matches have been posted yet.</div>
                        )}
                    </React.Fragment>
                );
            }))
        );
    };

    return (
        <div className={styles.resultsTab}>
            <div className={`container mt16`}>
                {isAdmin && (
                    <React.Fragment>
                        <div className={`row d-block ${!singlesDraws.length && !doublesDraws.length ? '' : 'd-md-none'}`}>
                            <div className={`col-12 mt24`}>
                                <div className={`link clickable`} onClick={() => showAddDrawPopup()} data-testid="dual-match.results.add-draw-btn">Add draw</div>
                            </div>
                        </div>
                    </React.Fragment>
                )}
                <div className={`row`}>
                    {isCollegeDualMatch
                        ? (
                            <>
                                {renderDoublesDraw()}
                                {renderSinglesDraw()}
                            </>
                        )
                        : (
                            <>
                                {renderSinglesDraw()}
                                {renderDoublesDraw()}
                            </>
                        )}
                </div>
            </div>
        </div>
    );
};

export default ResultsTabTmsDualMatch;
